// ** React Imports
import { Fragment } from "react";
import EpisodeCards from "./EpisodesCards";
import { CustomPagination } from "@store/action/GlobalAction";
import EpisodeHeader from "./EpisodeHeader";

const Episodes = (props) => {
  // ** Props
  const { activeView, setActiveView, store, setCurrentPage, t ,data,EpisodeLastPage} = props;
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };
  

  return (
    <div>
      <EpisodeHeader activeView={activeView} setActiveView={setActiveView} />
      {data.length ? (
        <Fragment>
          <EpisodeCards
            activeView={activeView}
            datas={store.data.data}
            data={data}
            t={t}
          />
          <div className="d-flex justify-content-center">
            {CustomPagination(EpisodeLastPage*5, 5, handlePageChange)}
          </div>
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center mt-2">
          <p>{t("No Results")}</p>
        </div>
      )}
    </div>
  );
};

export default Episodes;
